const storeDB = [
        {
          "store": ["足立壽司"],
          0: ["Closed","Closed"],
          1: ["12:00","21:30"],
          2: ["11:30","17:00"],
          3: ["17:00","21:30"],
          4: ["11:30","21:30"],
          5: ["12:00","21:30"],
          6: ["12:00","21:30"],
        },
        {
          "store": ["鮨隆"],
          0: ["11:30","21:00"],
          1: ["Closed","Closed"],
          2: ["11:30","21:00"],
          3: ["11:30","21:00"],
          4: ["11:30","21:00"],
          5: ["11:30","23:00"],
          6: ["11:30","23:00"],
        },
        {
          "store": ["匠壽司"],
          0: ["11:30","22:00"],
          1: ["11:30","22:00"],
          2: ["Closed","Closed"],
          3: ["11:30","22:00"],
          4: ["11:30","22:00"],
          5: ["11:30","23:00"],
          6: ["11:30","23:00"],
        },
        {
          "store": ["游壽司"],
          0: ["11:30","22:00"],
          1: ["11:30","22:00"],
          2: ["11:30","22:00"],
          3: ["Closed","Closed"],
          4: ["11:30","22:00"],
          5: ["11:30","23:00"],
          6: ["11:30","23:00"],
        },
        {
          "store": ["同壽司"],
          0: ["11:00","22:00"],
          1: ["11:00","22:00"],
          2: ["11:00","22:00"],
          3: ["11:00","22:00"],
          4: ["Closed","Closed"],
          5: ["11:00","22:00"],
          6: ["11:00","22:00"],
        },
        {
          "store": ["童壽司"],
          0: ["10:00","23:00"],
          1: ["11:00","23:00"],
          2: ["11:00","23:00"],
          3: ["11:00","23:00"],
          4: ["11:00","23:00"],
          5: ["Closed","Closed"],
          6: ["11:00","00:30"],
        },
        {
          "store": ["牡丹 天ぷら"],
          0: ["05:30","22:00"],
          1: ["11:30","22:00"],
          2: ["11:30","22:00"],
          3: ["11:30","22:00"],
          4: ["11:30","22:00"],
          5: ["11:30","22:00"],
          6: ["Closed","Closed"],
        },
        {
          "store": ["凜割烹"],
          0: ["11:30","21:30"],
          1: ["11:30","21:30"],
          2: ["11:30","21:30"],
          3: ["11:30","21:30"],
          4: ["11:30","21:30"],
          5: ["11:30","23:00"],
          6: ["11:30","23:00"],
        },
        {
          "store": ["鮨野村"],
          0: ["11:30","23:00"],
          1: ["11:30","22:00"],
          2: ["11:30","22:00"],
          3: ["11:30","22:00"],
          4: ["11:30","22:00"],
          5: ["11:30","23:00"],
          6: ["11:30","23:00"],
        },
        {
          "store": ["笹鮨"],
          0: ["11:00","23:00"],
          1: ["11:00","23:00"],
          2: ["11:00","23:00"],
          3: ["11:00","23:00"],
          4: ["11:00","23:00"],
          5: ["11:00","23:00"],
          6: ["11:00","23:00"],
        },
        {
          "store": ["鮨天本"],
          0: ["10:00","21:30"],
          1: ["10:30","21:30"],
          2: ["10:30","21:30"],
          3: ["10:30","21:30"],
          4: ["10:30","21:30"],
          5: ["10:30","21:30"],
          6: ["10:00","21:30"],
        },
        {
          "store": ["鮨七海"],
          0: ["09:30","21:30"],
          1: ["10:00","21:30"],
          2: ["10:00","21:30"],
          3: ["10:00","21:30"],
          4: ["10:00","21:30"],
          5: ["10:00","21:30"],
          6: ["09:30","21:30"],
        },
        {
          "store": ["Ukai 鐵板燒"],
          0: ["11:30","22:30"],
          1: ["11:30","22:30"],
          2: ["11:30","22:30"],
          3: ["11:30","22:30"],
          4: ["11:30","22:30"],
          5: ["11:30","22:30"],
          6: ["11:30","22:30"],
        },
        {
          "store": ["肉割烹"],
          0: ["Closed","Closed"],
          1: ["11:00","21:00"],
          2: ["11:00","21:00"],
          3: ["11:00","21:00"],
          4: ["11:00","21:00"],
          5: ["11:00","21:00"],
          6: ["17:00","23:00"],
        },
        {
          "store": ["よる"],
          0: ["11:00","22:00"],
          1: ["11:00","22:00"],
          2: ["11:00","22:00"],
          3: ["11:00","22:00"],
          4: ["11:00","22:00"],
          5: ["11:00","23:00"],
          6: ["11:00","23:00"],
        },
        {
          "store": ["和牛47"],
          0: ["11:30","21:00"],
          1: ["17:00","20:00"],
          2: ["17:00","20:00"],
          3: ["17:00","20:00"],
          4: ["17:00","20:00"],
          5: ["17:00","20:00"],
          6: ["17:00","20:00"],
        },
        {
          "store": ["謙安和"],
          0: ["15:00","23:30"],
          1: ["17:00","00:30"],
          2: ["17:00","00:30"],
          3: ["17:00","00:30"],
          4: ["17:00","01:30"],
          5: ["17:00","01:30"],
          6: ["15:00","01:30"],
        },
        {
          "store": ["凜割烹"],
          0: ["11:00 ","00:00"],
          1: ["11:00 ","00:00"],
          2: ["11:00 ","00:00"],
          3: ["11:00 ","00:00"],
          4: ["11:00 ","00:00"],
          5: ["11:00 ","00:00"],
          6: ["11:00 ","00:00"],
        },
        {
          "store": ["匠樂"],
          0: ["09:00","22:00"],
          1: ["09:00","22:00"],
          2: ["09:00","22:00"],
          3: ["09:00","22:00"],
          4: ["09:00","22:00"],
          5: ["09:00","23:00"],
          6: ["09:00","23:00"],
        },
        {
          "store": ["鮨十兵衛"],
          0: ["05:30","22:00"],
          1: ["Closed","Closed"],
          2: ["11:30","22:00"],
          3: ["11:30","22:00"],
          4: ["11:30","22:00"],
          5: ["11:30","22:00"],
          6: ["11:30","22:00"],
        },
        {
          "store": ["吟翔懷石料理"],
          0: ["12:00","22:00"],
          1: ["11:00","22:00"],
          2: ["11:00","22:00"],
          3: ["11:00","22:00"],
          4: ["11:00","22:00"],
          5: ["11:00","22:00"],
          6: ["11:00","22:00"],
        },
        {
          "store": ["初魚料亭"],
          0: ["11:00","22:00"],
          1: ["11:00","22:00"],
          2: ["11:00","22:00"],
          3: ["11:00","22:00"],
          4: ["11:00","22:00"],
          5: ["11:00","22:00"],
          6: ["11:00","22:00"],
        },
        {
          "store": ["吉兆割烹壽司"],
          0: ["12:00","00:00"],
          1: ["11:00","00:00"],
          2: ["11:00","00:00"],
          3: ["11:00","00:00"],
          4: ["11:00","00:00"],
          5: ["11:00","00:00"],
          6: ["11:00","00:00"],
        },
        {
          "store": ["野壽司"],
          0: ["11:00","22:00"],
          1: ["11:00","22:00"],
          2: ["11:00","22:00"],
          3: ["11:00","22:00"],
          4: ["11:00","22:00"],
          5: ["11:00","00:00"],
          6: ["11:00","00:00"],
        },
        {
          "store": ["一宗壽司"],
          0: ["07:00","15:00"],
          1: ["11:30","22:00"],
          2: ["11:30","22:00"],
          3: ["11:30","22:00"],
          4: ["11:30","22:00"],
          5: ["11:30","22:00"],
          6: ["07:00","15:00"],
        },
        {
          "store": ["鮨蕙"],
          0: ["11:00","04:00"],
          1: ["11:00","04:00"],
          2: ["11:00","04:00"],
          3: ["11:00","04:00"],
          4: ["11:00","04:00"],
          5: ["11:00","04:00"],
          6: ["11:00","04:00"],
        },
        {
          "store": ["小粋鮨割烹"],
          0: ["11:00","21:30"],
          1: ["11:00","21:30"],
          2: ["11:00","21:30"],
          3: ["Closed","Closed"],
          4: ["11:00","21:30"],
          5: ["11:00","21:30"],
          6: ["11:00","21:30"],
        },
        {
          "store": ["粋鮨"],
          0: ["11:30","22:00"],
          1: ["11:30","22:00"],
          2: ["11:30","22:00"],
          3: ["11:30","22:00"],
          4: ["11:30","22:00"],
          5: ["11:30","23:00"],
          6: ["11:30","23:00"],
        },
        {
          "store": ["錵鑶日本料理"],
          0: ["11:30","21:30"],
          1: ["11:30","21:30"],
          2: ["11:30","21:30"],
          3: ["11:30","21:30"],
          4: ["11:30","21:30"],
          5: ["11:30","21:30"],
          6: ["11:30","21:30"],
        },
        {
          "store": ["筌壽司割烹"],
          0: ["11:00","00:00"],
          1: ["11:00","00:00"],
          2: ["11:00","00:00"],
          3: ["11:00","00:00"],
          4: ["11:00","00:00"],
          5: ["11:00","00:00"],
          6: ["11:00","00:00"],
        },
        {
          "store": ["平淡天真"],
          0: ["11:30","22:00"],
          1: ["11:30","22:00"],
          2: ["11:30","22:00"],
          3: ["11:30","22:00"],
          4: ["11:30","22:00"],
          5: ["11:30","22:00"],
          6: ["11:30","22:00"],
        },
        {
          "store": ["新都里懷石料理"],
          0: ["11:30","22:00"],
          1: ["11:30","22:00"],
          2: ["11:30","22:00"],
          3: ["11:30","22:00"],
          4: ["11:30","22:00"],
          5: ["11:30","22:00"],
          6: ["11:30","22:00"],
        },
        {
          "store": ["彧割烹"],
          0: ["11:00","22:00"],
          1: ["11:00","23:00"],
          2: ["11:00","23:00"],
          3: ["11:00","23:00"],
          4: ["11:00","23:00"],
          5: ["11:00","23:00"],
          6: ["11:00","23:00"],
        },
        {
          "store": ["極壽司"],
          0: ["11:00","23:00"],
          1: ["11:00","23:00"],
          2: ["11:00","23:00"],
          3: ["11:00","23:00"],
          4: ["11:00","23:00"],
          5: ["11:00","23:00"],
          6: ["11:00","23:00"],
        },
        {
          "store": ["允壽司"],
          0: ["11:00","22:00"],
          1: ["Closed","Closed"],
          2: ["11:00","22:00"],
          3: ["11:00","22:00"],
          4: ["11:00","22:00"],
          5: ["11:00","22:00"],
          6: ["11:00","22:00"],
        },
        {
          "store": ["牛壽司"],
          0: ["11:00","22:30"],
          1: ["11:00","22:30"],
          2: ["11:00","22:30"],
          3: ["11:00","22:30"],
          4: ["11:00","22:30"],
          5: ["11:00","22:30"],
          6: ["11:00","22:30"],
        },
        {
          "store": ["上引水產"],
          0: ["Closed","Closed"],
          1: ["Closed","Closed"],
          2: ["11:30","21:30"],
          3: ["11:30","21:30"],
          4: ["11:30","21:30"],
          5: ["11:30","21:30"],
          6: ["11:30","21:30"],
        },
        {
          "store": ["三井料理美術館"],
          0: ["17:00","22:00"],
          1: ["11:00","22:00"],
          2: ["11:00","22:00"],
          3: ["11:00","22:00"],
          4: ["11:00","22:00"],
          5: ["11:00","22:00"],
          6: ["17:00","22:00"],
        },
        {
          "store": ["森壽司"],
          0: ["11:00","22:30"],
          1: ["11:00","22:30"],
          2: ["11:00","22:30"],
          3: ["11:00","22:30"],
          4: ["11:00","22:30"],
          5: ["11:00","22:30"],
          6: ["11:00","22:30"],
        },
        {
          "store": ["高玉日本料理"],
          0: ["11:00","23:00"],
          1: ["11:00","23:00"],
          2: ["11:00","23:00"],
          3: ["11:00","23:00"],
          4: ["11:00","23:00"],
          5: ["11:00","23:00"],
          6: ["11:00","23:00"],
        },
        {
          "store": ["丸壽司"],
          0: ["11:00","01:00"],
          1: ["11:00","01:00"],
          2: ["11:00","01:00"],
          3: ["11:00","01:00"],
          4: ["11:00","01:00"],
          5: ["11:00","01:00"],
          6: ["11:00","01:00"],
        },
        {
          "store": ["綠水棧"],
          0: ["11:00","01:00"],
          1: ["Closed","Closed"],
          2: ["11:00","01:00"],
          3: ["11:00","01:00"],
          4: ["11:00","01:00"],
          5: ["11:00","01:00"],
          6: ["11:00","01:00"],
        },
        {
          "store": ["牛二壽司"],
          0: ["17:00","22:00"],
          1: ["12:00","22:00"],
          2: ["12:00","22:00"],
          3: ["12:00","22:00"],
          4: ["12:00","22:00"],
          5: ["12:00","22:00"],
          6: ["17:00","22:00"],
        },
        {
          "store": ["子元日本料理"],
          0: ["10:00","22:30"],
          1: ["10:00","22:30"],
          2: ["10:00","22:30"],
          3: ["10:00","22:30"],
          4: ["10:00","22:30"],
          5: ["10:00","00:30"],
          6: ["10:00","00:30"],
        },
        {
          "store": ["逸鮮棧"],
          0: ["Closed","Closed"],
          1: ["11:30","22:00"],
          2: ["11:30","22:00"],
          3: ["11:30","22:00"],
          4: ["11:30","22:00"],
          5: ["11:30","22:00"],
          6: ["17:00","22:00"],
        },
        {
          "store": ["旬採鮨処"],
          0: ["09:00","22:00"],
          1: ["09:00","21:30"],
          2: ["Closed","Closed"],
          3: ["09:00","21:30"],
          4: ["09:00","21:30"],
          5: ["09:00","21:30"],
          6: ["09:00","22:00"],
        },
        {
          "store": ["鯈樂"],
          0: ["10:00","23:00"],
          1: ["10:00","23:00"],
          2: ["10:00","23:00"],
          3: ["10:00","23:00"],
          4: ["10:00","23:00"],
          5: ["10:00","23:00"],
          6: ["10:00","23:00"],
        },
        {
          "store": ["鯤壽司"],
          0: ["11:00","22:30"],
          1: ["11:00","23:00"],
          2: ["11:00","23:00"],
          3: ["11:00","23:00"],
          4: ["11:00","23:00"],
          5: ["11:00","23:00"],
          6: ["11:00","23:00"],
        },
        {
          "store": ["初魚料亭"],
          0: ["08:00","22:30"],
          1: ["08:00","22:30"],
          2: ["08:00","22:30"],
          3: ["08:00","22:30"],
          4: ["08:00","22:30"],
          5: ["08:00","22:30"],
          6: ["08:00","22:30"],
        },
        {
          "store": ["煮海"],
          0: ["16:30","22:30"],
          1: ["11:00","22:30"],
          2: ["11:00","22:30"],
          3: ["11:00","22:30"],
          4: ["11:00","22:30"],
          5: ["11:00","23:00"],
          6: ["11:30","23:00"],
        },
        {
          "store": ["德壽司"],
          0: ["05:30","02:00"],
          1: ["05:30","02:00"],
          2: ["05:30","02:00"],
          3: ["05:30","02:00"],
          4: ["05:30","02:00"],
          5: ["05:30","02:00"],
          6: ["05:30","02:00"],
        },
      ]


export default storeDB;